import { useQuery } from '@tanstack/react-query';

import type { Medical } from '~entities/student/modal/medical';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetClassMedicalDetailsResponse {
  items: Array<Item>;
  pagination: Pagination;
}

export interface Item {
  _id: string;
  firstName: string;
  lastName: string;
  name: string;
  medical: Medical;
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface StudentWithMedical {
  name: string;
  medical: Medical;
}

interface GetClassMedicalDetailsParams {
  classId: string;
  page?: number;
  limit?: number;
}

export const getClassMedicalDetailsAPI = async (
  params: GetClassMedicalDetailsParams,
) => {
  const response = await baseAPI.get<GetClassMedicalDetailsResponse>(
    `/students/${params.classId}/class/medical`,
    {
      params: {
        page: params.page,
        limit: params.limit,
      },
    },
  );
  return response.data;
};

export const useGetClassMedicalDetails = (
  params: GetClassMedicalDetailsParams,
) => {
  return useQuery({
    queryKey: [KEYS.CLASS_MEDICAL, params],
    queryFn: () => getClassMedicalDetailsAPI(params),
  });
};
